import * as React from "react";
const SvgAgentPermissionsIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 64 64", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 32, cy: 32.001, r: 32.001, fill: "#a5beff", style: {
  fill: "#a5beff",
  fill: "color(display-p3 .6471 .7451 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#e1ebff", d: "M28.05 9.848c2.038-2.464 5.862-2.464 7.9 0l6.254 11.095 9.453 7.894a4.95 4.95 0 0 1 0 6.327l-9.453 7.895-6.254 11.094c-2.038 2.465-5.862 2.465-7.9 0L21.795 43.06l-9.454-7.895a4.95 4.95 0 0 1 0-6.327l9.454-7.894z", style: {
  fill: "#e1ebff",
  fill: "color(display-p3 .8824 .9216 1)",
  fillOpacity: 1
} }));
export default SvgAgentPermissionsIcon;
